// Port of api/fuel/app/classes/insights/hindex/share.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'share',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}
        if (!owner.get_count_plays || !owner.get_count_plays()) return {}

        var segments = {
            own: [],
            all: []
        }
        for (var s = 0; s < 20; s++) {
            segments.own.push(0)
            segments.all.push(0)
        }

        var ownRows = Util.query(
            'SELECT track_share FROM hindex_track WHERE hindex_id = ' + this._data.type.get_id() +
            ' AND track_hindex = ' + this._data.current.get_hindex()
        )

        var values = []
        for (var i = 0; i < ownRows.length; i++) {
            values.push(parseFloat(ownRows[i].track_share))
        }

        for (var j = 0; j < values.length; j++) {
            var index = Math.floor((values[j] - 1) / 5)
            if (index === -1) index = 0
            if (index >= 0 && index < 20) segments.own[index]++
        }

        if (values.length) {
            for (var k = 0; k < 20; k++) {
                segments.own[k] = Math.round(((100 / values.length) * segments.own[k]) * 10) / 10
            }
        }

        var allRows = Util.query(
            'SELECT track_share FROM hindex_track WHERE hindex_id = ' + this._data.type.get_id() +
            ' AND track_hindex > 1'
        )

        var allValues = []
        for (var ai = 0; ai < allRows.length; ai++) {
            allValues.push(parseFloat(allRows[ai].track_share))
        }

        for (var aj = 0; aj < allValues.length; aj++) {
            var aindex = Math.floor((allValues[aj] - 1) / 5)
            if (aindex === -1) aindex = 0
            if (aindex >= 0 && aindex < 20) segments.all[aindex]++
        }

        if (allValues.length) {
            for (var ak = 0; ak < 20; ak++) {
                segments.all[ak] = Math.round(((100 / allValues.length) * segments.all[ak]) * 10) / 10
            }
        }

        return {
            share: segments
        }

    }
})
